import styled from 'styled-components';
import { px2rem } from '../../../stylesheets/tools';

const StyledTags = styled.div`
  .tags__wrapper {
    display: flex;
    flex-wrap: wrap;
  }

  .tags__tag {
    padding: 5px 8px 3px;
    margin: 5px 10px 5px 0;
    text-transform: uppercase;
    border: 1px solid #000;
    font-size: ${px2rem('14px')};
    line-height: 1;
    letter-spacing: 0.4px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  a.tags__tag:hover {
    background: #000;
    color: #fff;
  }
`;

export default StyledTags;
